// extracted by mini-css-extract-plugin
export default {"flexCenter":"LangSelector_flexCenter__32UgQ","select":"LangSelector_select__KUwfa"};